module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp2_0.cc2d6dc5.png";